<template>
  <page icon="address-book" :title="`#${client.id} - ${client.legal_name}`">
    <div slot="tools">
      <div class="tabs is-toggle">
        <ul>
          <router-link exact tag="li" :to="{ name: 'client-overview', params: { client: this.$route.params.client }}">
            <a>
              <icon icon="chart-area"/>
              <span>{{ Naming.Overview }}</span>
            </a>
          </router-link>
          <router-link exact tag="li" :to="{ name: 'client-sites', params: { client: this.$route.params.client }}"
                       v-if="$root.hasAbility('manage-client-sites', 'Billow\\Models\\Client')">
            <a>
              <icon icon="building"/>
              <span>{{ Naming.Sites }}</span>
            </a>
          </router-link>
          <router-link
              v-if="isAdmin" exact tag="li"
              :to="{ name: 'client-users', params: { client: this.$route.params.client }}">
            <a>
              <icon icon="users"/>
              <span>{{ Naming.Client }} {{ Naming.Users }}</span>
            </a>
          </router-link>
          <router-link exact tag="li" :to="{ name: 'client-edit', params: { client: this.$route.params.client }}"
                       v-if="$root.hasAbility('edit-clients', 'Billow\\Models\\Client')">
            <a>
              <icon icon="pencil-alt"/>
              <span>Edit Information</span>
            </a>
          </router-link>
        </ul>
      </div>
    </div>
    <router-view/>
  </page>
</template>

<script>
import {mapGetters} from 'vuex'

export default {

  data: () => ({
    loaded: false
  }),

  created() {
    this.$store.dispatch('client/loadClient', this.$route.params.client).then(() => {
      this.loaded = true
    })
  },

  computed: {
    ...mapGetters('client', [
      'client',
      'overview'
    ])
  }

}
</script>
